if (!customElements.get('hola-coffee-purchase')) {
  customElements.define('hola-coffee-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.products = JSON.parse(this.querySelector('[data-coffee-products]').textContent);
      this.product = this.products.find(p => p.handle === JSON.parse(this.querySelector('[data-current-handle]').textContent));
      this.form = this.querySelector('form');
      this.variantControl = this.querySelector('[data-coffee-variant]');
      this.mode = this.querySelector('[name="hola_purchase"][value="once"]');
      this.planInput = this.querySelector('[data-hola-selling-plan]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency || 'USD'});
      const params = new URL(location.href).searchParams;
      const requestedPlan = params.get('selling_plan');
      const initial = this.currentVariant();
      const allocation = initial?.allocations.find(p => p.id === requestedPlan);
      if (allocation) {
        this.querySelector('[name="hola_purchase"][value="subscribe"]').checked = true;
        const frequency = /\b4\s*weeks?\b/i.test(allocation.name) ? '4' : '2';
        this.querySelector(`[name="hola_frequency"][value="${frequency}"]`).checked = true;
      }
      this.querySelector('[data-purchase-options]').hidden = false;
      this.classList.add('hola-shopping--ready');
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('input', e => {if(e.target.name === 'quantity') this.update(false);});
      this.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
        const quantity = this.form.querySelector('[name="quantity"]');
        quantity.value = Math.max(1,(Number(quantity.value) || 1)+Number(button.dataset.quantityStep));
        this.update(false);
      }));
      this.form.addEventListener('submit', e => this.add(e));
      this.update(false);
    }
    currentVariant() {return this.product?.variants.find(v => v.id === this.variantControl.value);}
    currentFrequency() {return this.querySelector('[name="hola_frequency"]:checked').value;}
    allocation(variant, frequency) {return variant?.allocations.find(p => new RegExp(`\\b${frequency}\\s*weeks?\\b`,'i').test(p.name));}
    update(changeUrl = true) {
      const variant = this.currentVariant();
      if (!variant) return;
      let frequency = this.currentFrequency();
      if(!this.allocation(variant,frequency)) {
        const availableFrequency = ['2','4'].find(f=>this.allocation(variant,f));
        if(availableFrequency) {frequency=availableFrequency;this.querySelector(`[name="hola_frequency"][value="${frequency}"]`).checked=true;}
      }
      const plan = this.allocation(variant,frequency);
      const subRadio = this.querySelector('[name="hola_purchase"][value="subscribe"]');
      subRadio.disabled = !plan;
      if (!plan) this.mode.checked = true;
      const subscription = subRadio.checked && plan;
      this.planInput.disabled = !subscription;
      this.planInput.value = subscription ? plan.id : '';
      this.querySelector('[data-frequency-panel]').hidden = !subscription;
      this.querySelector('[data-once-price]').textContent = this.money.format(variant.price/100);
      this.querySelector('[data-subscribe-price]').textContent = plan ? this.money.format(plan.price/100) : 'Unavailable';
      this.querySelectorAll('[name="hola_frequency"]').forEach(input => {input.disabled = !this.allocation(variant,input.value);});
      const quantity = Math.max(1,Number(this.form.querySelector('[name="quantity"]').value) || 1);
      this.querySelector('[data-add-label]').textContent = variant.available ? `${subscription ? 'Subscribe' : 'Add to bag'} · ${this.money.format((subscription ? plan.price : variant.price)*quantity/100)}` : 'Sold out';
      this.querySelector('[type="submit"]').disabled = !variant.available || this.busy;
      this.querySelectorAll('[data-coffee-link]').forEach(link => {
        const product = this.products.find(p => p.handle === link.dataset.coffeeLink);
        const next = product?.variants.find(v => v.title === variant.title);
        if (!next) return;
        const url = new URL(product.url,location.origin);
        url.searchParams.set('variant',next.id);
        const nextPlan = this.allocation(next,frequency);
        if(subscription && nextPlan) url.searchParams.set('selling_plan',nextPlan.id);
        link.href = url.pathname + url.search;
      });
      if(changeUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant',variant.id);
        if(subscription) url.searchParams.set('selling_plan',plan.id); else url.searchParams.delete('selling_plan');
        history.replaceState({},'',url.pathname+url.search+url.hash);
      }
    }
    async add(event) {
      event.preventDefault();
      if(this.busy || !this.form.reportValidity()) return;
      const variant = this.currentVariant();
      if(!variant?.available) return;
      const subscription = this.querySelector('[name="hola_purchase"][value="subscribe"]').checked;
      const plan = this.allocation(variant,this.currentFrequency());
      if(subscription && !plan) return;
      this.busy = true;
      const error = this.querySelector('[data-coffee-error]');
      error.hidden = true;
      const submit = this.querySelector('[type="submit"]');
      submit.disabled = true;
      submit.setAttribute('aria-busy','true');
      this.querySelector('[data-add-label]').textContent = 'Adding to your bag…';
      const data = new FormData();
      data.set('id',variant.id);
      data.set('quantity',String(Math.max(1,Number(this.form.querySelector('[name="quantity"]').value) || 1)));
      if(subscription) data.set('selling_plan',plan.id);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      let added = false;
      try {
      if(cart) {
        data.set('sections',cart.getSectionsToRender().map(s=>s.id).join(','));
        data.set('sections_url',location.pathname);
        cart.setActiveElement(submit);
      }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:data});
        const result = await response.json();
        if(!response.ok || result.status) throw new Error(result.description || 'We couldn’t add this coffee. Please try again.');
        added = true;
        if(cart && result.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
          if(typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'hola-product',productVariantId:variant.id,cartData:result});
        } else {location.assign(window.routes?.cart_url || '/cart');}
      } catch(e) {if(added) {location.assign(window.routes?.cart_url || '/cart');return;} error.textContent=e.message;error.hidden=false;} finally {this.busy=false;submit.removeAttribute('aria-busy');this.update(false);}
    }
  });
}
